export const formatToUSNumber = (number: any) => {
    return Number(number).toLocaleString("en-US");
}

